import { Directive } from '@angular/core';

@Directive({
  selector: '[fInnerErrorActions]'
})
export class FireflyInnerErrorDirective {}
